// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as CTABar$Showside from "./CTABar.bs.js";
import * as PDPForm$Showside from "./PDPForm.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as Accordion$Showside from "./Accordion.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as IconCheck$Showside from "../icons/IconCheck.bs.js";
import * as IconTimes$Showside from "../icons/IconTimes.bs.js";
import * as IconArrival$Showside from "../icons/IconArrival.bs.js";
import * as IconShipping$Showside from "../icons/IconShipping.bs.js";
import * as ProductPrice$Showside from "./ProductPrice.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as PDPCTAWrapper$Showside from "./PDPCTAWrapper.bs.js";
import * as ProductBadges$Showside from "./ProductBadges.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as ProductReviews$Showside from "./ProductReviews.bs.js";
import * as QuantityPicker$Showside from "./QuantityPicker.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as SizeGuideModal$Showside from "./SizeGuideModal.bs.js";
import ReactVisibilitySensor from "react-visibility-sensor";
import * as ResizeObserver2$Showside from "../utils/ResizeObserver2.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as CustomerTheaterXyz$Showside from "../customers/CustomerTheaterXyz.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as ProductDetailsConfig$Showside from "../types/ProductDetailsConfig.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ProductDetailsContext$Showside from "../context/ProductDetailsContext.bs.js";
import * as ProductDetailsConfigId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/ProductDetailsConfigId.bs.js";
import * as MetafieldDrivenColorPicker$Showside from "./MetafieldDrivenColorPicker.bs.js";
function PDPContentDetailsCard$DetailedAccordions(Props) {
  var variant = Props.variant;
  var product = Props.product;
  var detailedSections = Props.detailedSections;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["flex flex-col smartnav-pdp__description"]))
  }, React.createElement(Accordion$Showside.make, {
    id: product.id,
    sections: Accordion$Showside.fromDetailedSections(detailedSections, product, variant, match$1.config),
    onChangeFocus: function (id) {
      if (id === "description") {
        return Curry.app(trackEvent, ["product details:description", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      }
    },
    titleStyle: "semibold-uppercase",
    forceCollapsible: true
  }));
}
PDPContentDetailsCard$DetailedAccordions.displayName = "PDPContentDetailsCard.DetailedAccordions";
var DetailedAccordions = {
  make: PDPContentDetailsCard$DetailedAccordions
};
function PDPContentDetailsCard$MoreSections(Props) {
  var product = Props.product;
  var moreSections = Props.moreSections;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["flex flex-col"]))
  }, React.createElement(Accordion$Showside.make, {
    id: product.id,
    sections: moreSections,
    onChangeFocus: function (id) {
      if (id === "description") {
        return Curry.app(trackEvent, ["product details:description", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      }
    },
    titleStyle: "semibold-uppercase"
  }));
}
PDPContentDetailsCard$MoreSections.displayName = "PDPContentDetailsCard.MoreSections";
var MoreSections = {
  make: PDPContentDetailsCard$MoreSections
};
function PDPContentDetailsCard$PromoSection(Props) {
  var data = Props.data;
  var product = Props.product;
  var variant = Props.variant;
  var layout = Props.layout;
  var match = ConfigurationProvider$Showside.use(undefined);
  var contents = ProductDetailsConfig$Showside.isVisible(product, variant, data.visible) ? ProductDetailsConfig$Showside.Content.renderContents(CSS$Showside.prefix("text-product-promo-label"), product, variant, match.config, data.contents) : [];
  if (contents.length !== 0) {
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: "pdp-product-promo",
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["p-3 text-lg text-product-promo-label font-normal bg-product-promo-main select-text text-center", layout !== 1 ? "my-3 col-span-1" : "col-span-2"]))
      }, contents)
    });
  } else {
    return null;
  }
}
PDPContentDetailsCard$PromoSection.displayName = "PDPContentDetailsCard.PromoSection";
var PromoSection = {
  make: PDPContentDetailsCard$PromoSection
};
function make(data, product, variant, param) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var renderSection = function (section) {
    var content = Belt_Option.getWithDefault(ProductDetailsConfig$Showside.Content.renderContent(undefined, undefined, product, variant, config, section.content), null);
    var isAvailable;
    if (variant !== undefined) {
      var match = variant.availability;
      isAvailable = match ? true : false;
    } else {
      isAvailable = !Product$Showside.isOutOfStock(product);
    }
    var iconCn = CSS$Showside.prefix("w-5.5 h-5.5 flex-shrink-0");
    var availabilityIcon = React.createElement("div", {
      className: Cn.make([iconCn, CSS$Showside.prefix("flex items-center justify-center")])
    }, isAvailable ? React.createElement(IconCheck$Showside.make, {
      className: CSS$Showside.prefix("w-4 h-4")
    }) : React.createElement(IconTimes$Showside.make, {
      className: CSS$Showside.prefix("w-4 h-4")
    }));
    var match$1 = Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.toString, section.id);
    var match$2 = ProductDetailsConfig$Showside.Content.getDynamicSource(section.content);
    var match$3 = section.iconUrl.trim();
    var icon;
    var exit = 0;
    switch (match$1) {
      case "arrival":
        icon = React.createElement(IconArrival$Showside.make, {
          className: iconCn
        });
        break;
      case "availability":
        icon = availabilityIcon;
        break;
      case "shippingShort":
        icon = React.createElement(IconShipping$Showside.make, {
          className: iconCn
        });
        break;
      default:
        if (match$2 !== undefined && match$2.TAG === /* Availability */3) {
          icon = availabilityIcon;
        } else {
          exit = 1;
        }
    }
    if (exit === 1) {
      if (match$3 !== "") {
        icon = React.createElement("div", {
          className: Cn.make([iconCn, CSS$Showside.prefix("relative")])
        }, React.createElement(SmartImg$Showside.Sized.make, {
          src: match$3,
          containerWidth: 16,
          containerHeight: 16,
          fit: /* Contain */2,
          priority: 0
        }));
      } else {
        var match$4 = section.content;
        icon = match$4.TAG === /* Image */2 ? null : React.createElement("div", {
          className: Cn.make([iconCn, CSS$Showside.prefix("relative items-center justify-center flex")])
        }, React.createElement("div", {
          className: CSS$Showside.prefix("rounded-full bg-primary w-2 h-2 inline-block")
        }));
      }
    }
    var match$5 = Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.toString, section.id);
    var match$6 = section.content;
    var extraCns = match$5 === "availability" ? isAvailable ? "text-primary" : "text-tertiary" : match$6.TAG === /* DynamicSource */0 && match$6._0.source.TAG === /* Availability */3 && !isAvailable ? "text-tertiary" : "text-primary";
    var match$7 = Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.toString, section.id);
    var dataTestId;
    switch (match$7) {
      case "arrival":
        dataTestId = "pdp-product-arrival-summary";
        break;
      case "availability":
        dataTestId = "pdp-product-availability-summary";
        break;
      case "shippingShort":
        dataTestId = "pdp-product-shipping-summary";
        break;
      default:
        dataTestId = "pdp-product-custom-summary";
    }
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: dataTestId,
      children: React.createElement("div", {
        key: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.toString, section.id),
        className: CSS$Showside.prefix(Cn.make(["flex items-start space-x-2", extraCns]))
      }, icon, content)
    });
  };
  if (data.length !== 0) {
    return Accordion$Showside.makeSection(undefined, "summary", Caml_option.some(React.createElement("div", {
      className: CSS$Showside.prefix("flex space-y-2 text-primary text-lg flex-col mt-2")
    }, Belt_Array.map(data, renderSection))), undefined, undefined, undefined, undefined, undefined);
  }
}
var SummarySection = {
  make: make
};
function PDPContentDetailsCard(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var productCategory = Props.productCategory;
  var shouldForceMobileOpt = Props.shouldForceMobile;
  var scrollToDetailsRef = Props.scrollToDetailsRef;
  var onCTAButtonVisibilityChangeOpt = Props.onCTAButtonVisibilityChange;
  var showHeaderOpt = Props.showHeader;
  var headerSizeOpt = Props.headerSize;
  var largeTitleStyleOpt = Props.largeTitleStyle;
  var titleSizeOpt = Props.titleSize;
  var optionSizeOpt = Props.optionSize;
  var optionStyleOpt = Props.optionStyle;
  var colorOptionSizeOpt = Props.colorOptionSize;
  var quantityOptionSize = Props.quantityOptionSize;
  var moreSectionsOpt = Props.moreSections;
  var quantity = Props.quantity;
  var setQuantity = Props.setQuantity;
  var stickyCTA = Props.stickyCTA;
  var layoutOpt = Props.layout;
  var sectionsOpt = Props.sections;
  var showSizeGuideOpt = Props.showSizeGuide;
  var singleColumnHorizontalPaddingOpt = Props.singleColumnHorizontalPadding;
  var showPrimaryCTAOpt = Props.showPrimaryCTA;
  var showSecondaryCTAOpt = Props.showSecondaryCTA;
  var showTertiaryCTAOpt = Props.showTertiaryCTA;
  var showFavoriteButtonOpt = Props.showFavoriteButton;
  var showCustomColorsOpt = Props.showCustomColors;
  var tabIndex = Props.tabIndex;
  var shouldForceMobile = shouldForceMobileOpt !== undefined ? shouldForceMobileOpt : false;
  var onCTAButtonVisibilityChange = onCTAButtonVisibilityChangeOpt !== undefined ? onCTAButtonVisibilityChangeOpt : function (visible) {};
  var showHeader = showHeaderOpt !== undefined ? showHeaderOpt : true;
  var headerSize = headerSizeOpt !== undefined ? headerSizeOpt : /* Base */0;
  var largeTitleStyle = largeTitleStyleOpt !== undefined ? largeTitleStyleOpt : "medium";
  var titleSize = titleSizeOpt !== undefined ? titleSizeOpt : "base";
  var optionSize = optionSizeOpt !== undefined ? optionSizeOpt : /* Lg */3;
  var optionStyle = optionStyleOpt !== undefined ? optionStyleOpt : /* Rounded */1;
  var colorOptionSize = colorOptionSizeOpt !== undefined ? colorOptionSizeOpt : /* Lg */3;
  var moreSections = moreSectionsOpt !== undefined ? moreSectionsOpt : [];
  var layout = layoutOpt !== undefined ? layoutOpt : /* SingleColumn */0;
  var sections = sectionsOpt !== undefined ? sectionsOpt : ["promo", "summary", "variants", "quantity", "cta"];
  var showSizeGuide = showSizeGuideOpt !== undefined ? showSizeGuideOpt : true;
  var singleColumnHorizontalPadding = singleColumnHorizontalPaddingOpt !== undefined ? singleColumnHorizontalPaddingOpt : "px-6";
  var showPrimaryCTA = showPrimaryCTAOpt !== undefined ? showPrimaryCTAOpt : true;
  var showSecondaryCTA = showSecondaryCTAOpt !== undefined ? showSecondaryCTAOpt : true;
  var showTertiaryCTA = showTertiaryCTAOpt !== undefined ? showTertiaryCTAOpt : true;
  var showFavoriteButton = showFavoriteButtonOpt !== undefined ? showFavoriteButtonOpt : true;
  var showCustomColors = showCustomColorsOpt !== undefined ? showCustomColorsOpt : true;
  var store = StoreProvider$Showside.use(undefined);
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var settings = match.config.settings;
  var match$1 = ViewportContext$Showside.use(undefined);
  var entrypointContext = EntrypointContext$Showside.use(undefined);
  var pdpConfig = ProductDetailsContext$Showside.use(undefined);
  var trackEvent = entrypointContext.trackEvent;
  RouterProvider$Showside.useRouter(undefined);
  var desktopHeaderContentRef = React.useRef(null);
  var isMobile = match$1.isMobile || shouldForceMobile;
  var stickyCTA$1 = Belt_Option.getWithDefault(stickyCTA, isMobile);
  var selectedVariant = variant !== undefined ? variant : Product$Showside.getVariantBySelector(product, displayVariantBy);
  var match$2 = React.useState(function () {
    return false;
  });
  var setShowScrollToTopButton = match$2[1];
  var showScrollToTopButton = match$2[0];
  var productDetailsSize = Belt_Option.getWithDefault(ResizeObserver2$Showside.useResizeObserver(desktopHeaderContentRef), {
    width: -1,
    height: -1,
    top: -1
  });
  var renderSizeGuideButton = function (param) {
    var sizeGuide = settings.pdpSizeGuide;
    if (sizeGuide === undefined) {
      return null;
    }
    if (!showSizeGuide) {
      return null;
    }
    var tmp = {
      sizeGuide: sizeGuide,
      product: product,
      variant: selectedVariant
    };
    var tmp$1 = Belt_Option.map(productCategory, function (category) {
      return category.id;
    });
    if (tmp$1 !== undefined) {
      tmp.activeCategoryId = Caml_option.valFromOption(tmp$1);
    }
    return React.createElement(SizeGuideModal$Showside.make, tmp);
  };
  var match$3 = PDPForm$Showside.use(undefined);
  var fields = match$3.form.fields;
  var options = Belt_Array.keep(Belt_Array.mapWithIndex(fields, function (i, field) {
    var separator = i === (fields.length - 2 | 0) ? " & " : i === (fields.length - 1 | 0) ? "" : ", ";
    if (field.options.length > 1) {
      return field.label + separator;
    } else {
      return "";
    }
  }), function (x) {
    return x !== "";
  }).join("");
  var options$1 = options === "" ? undefined : "See All " + options + " Options";
  var scrollToTopButton = options$1 !== undefined ? Caml_option.some(React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([stickyCTA$1 && showScrollToTopButton ? "opacity-100" : "opacity-0 pointer-events-none", "font-bold text-sm absolute bottom-2 left-6 transition-opacity duration-150"]))
  }, React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-see-all-options-button",
    children: React.createElement("span", {
      className: CSS$Showside.prefix("text-accent hover:underline cursor-pointer select-none"),
      onClick: function (e) {
        Curry._1(scrollToDetailsRef.current, undefined);
      }
    }, options$1.toUpperCase())
  }))) : undefined;
  var showingDesktopSticky = stickyCTA$1 && showScrollToTopButton && Belt_Option.isSome(scrollToTopButton);
  var productPriceContent = React.createElement(ProductPrice$Showside.make, {
    at: /* PDP */0,
    product: product,
    variant: selectedVariant,
    size: isMobile ? /* Md */1 : /* Xl */0,
    align: isMobile ? /* Right */1 : /* Left */0,
    minPriceFirst: !isMobile,
    multiline: isMobile,
    bold: false
  });
  var productPriceContent$1 = isMobile ? React.createElement("div", {
    className: CSS$Showside.prefix("-mt-2")
  }, productPriceContent) : React.createElement("div", {
    className: CSS$Showside.prefix("pt-2")
  }, productPriceContent);
  var tmp = {
    at: /* PDP */0,
    product: product,
    className: CSS$Showside.prefix("mt-2")
  };
  if (variant !== undefined) {
    tmp.variant = Caml_option.valFromOption(variant);
  }
  var headerContent = React.createElement("div", {
    className: CSS$Showside.prefix("flex items-start select-text flex-col")
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["flex", isMobile ? "w-full" : "w-9/12", layout !== 1 ? isMobile ? "pt-6" : "py-6" : "", "space-x-4"]))
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([showingDesktopSticky ? "scale-85" : "scale-100", "transform-gpu transition-transform origin-top-left duration-150 flex-grow"]))
  }, React.createElement(ProductBadges$Showside.make, {
    className: CSS$Showside.prefix("mb-2"),
    dataTestId: "pdp-product-badges",
    product: product,
    variant: selectedVariant
  }), React.createElement("div", {
    "aria-level": 1,
    className: CSS$Showside.prefix(Cn.make(["text-secondary font-heading pb-1 select-text", headerSize ? "text-5xl font-semibold" : "text-xl"])),
    role: "heading",
    tabIndex: 0
  }, React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-product-title",
    children: React.createElement("div", undefined, Product$Showside.getDisplayName(store, selectedVariant, product))
  })), React.createElement(ConditionalRender$Showside.When.make, {
    condition: !isMobile,
    children: productPriceContent$1
  }), React.createElement(ProductReviews$Showside.make, tmp)), React.createElement(ConditionalRender$Showside.When.make, {
    condition: isMobile,
    children: productPriceContent$1
  }), Belt_Option.getWithDefault(scrollToTopButton, null)));
  var headerContent$1 = stickyCTA$1 ? React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(desktopHeaderContentRef),
    className: CSS$Showside.prefix("sticky top-0 bg-main -mx-6 px-6 mb-4"),
    style: {
      zIndex: "11"
    }
  }, headerContent) : React.createElement("div", {
    className: CSS$Showside.prefix("mb-4")
  }, headerContent);
  var showQuantity = settings.quantityPicker;
  var renderQuantity = function (param) {
    var tmp = {
      optionSize: optionSize,
      optionStyle: optionStyle,
      quantity: quantity,
      setQuantity: setQuantity
    };
    if (quantityOptionSize !== undefined) {
      tmp.quantityOptionSize = Caml_option.valFromOption(quantityOptionSize);
    }
    return React.createElement(QuantityPicker$Showside.make, tmp);
  };
  var renderAccordionContent = function (moreSectionsOpt, param) {
    var moreSections = moreSectionsOpt !== undefined ? moreSectionsOpt : [];
    var inline = layout === /* Inline */2;
    var partial_arg = inline;
    return React.createElement(Accordion$Showside.make, {
      id: product.id,
      sections: Belt_Array.concat(Belt_Array.keepMap(sections, function (param) {
        var inline = partial_arg !== undefined ? partial_arg : false;
        if (param === "variants") {
          var tmp = {
            dropdownDirection: settings.desktopPDPLayout === /* Vertical */2 ? [inline ? /* Right */1 : /* Left */0, /* Top */0] : [inline ? /* Right */1 : /* Left */0, /* Bottom */1],
            optionSize: optionSize,
            optionStyle: optionStyle,
            colorOptionSize: colorOptionSize,
            hideEmptyOptions: inline,
            scrollIntoViewOnError: !inline,
            onRender: function (field, fields, fieldElement) {
              var requireSizeGuide = Caml_obj.equal(Belt_Option.map(Belt_Array.getBy(fields, function (f) {
                return f.name.toLowerCase().includes("size");
              }), function (f) {
                return f.id;
              }), Caml_option.some(field.id));
              var tmp = {
                active: Curry._1(PDPForm$Showside.FieldId.toString, field.id),
                id: Curry._1(PDPForm$Showside.FieldId.toString, field.id),
                className: inline ? CSS$Showside.prefix("pb-2") : CSS$Showside.prefix("py-4"),
                titleStyle: largeTitleStyle,
                titleSize: titleSize,
                children: null
              };
              var tmp$1 = requireSizeGuide ? Caml_option.some(renderSizeGuideButton(undefined)) : undefined;
              if (tmp$1 !== undefined) {
                tmp.contentRight = Caml_option.valFromOption(tmp$1);
              }
              var match = field.value;
              var match$1 = field.initialValue;
              return React.createElement(ReactVisibilitySensor, {
                partialVisibility: false,
                onChange: function (visible) {
                  Curry._1(setShowScrollToTopButton, function (param) {
                    return !visible;
                  });
                },
                children: React.createElement(DataAttribute$Showside.make, {
                  dataSectionId: field.name.toLocaleLowerCase() + "s",
                  children: React.createElement("div", {
                    className: inline ? CSS$Showside.prefix("pr-8") : CSS$Showside.prefix("pb-2")
                  }, React.createElement(Accordion$Showside.Header.make, tmp, field.label, React.createElement(ConditionalRender$Showside.OptionMap.make, {
                    option: match !== undefined ? field.value : match$1 !== undefined ? field.initialValue : undefined,
                    condition: function (param) {
                      return field.kind === /* SwatchButton */1;
                    },
                    children: function (value) {
                      return React.createElement(React.Fragment, undefined, ": ", React.createElement("div", {
                        className: CSS$Showside.prefix("inline text-secondary font-bold")
                      }, value));
                    }
                  })), fieldElement)
                })
              });
            }
          };
          var tmp$1 = inline ? 5 : undefined;
          if (tmp$1 !== undefined) {
            tmp.truncateAt = tmp$1;
          }
          if (tabIndex !== undefined) {
            tmp.tabIndex = Caml_option.valFromOption(tabIndex);
          }
          return Accordion$Showside.makeSection({
            TAG: /* Element */1,
            _0: null
          }, inline ? "sticky-variants" : "variants", Caml_option.some(React.createElement(React.Fragment, undefined, showCustomColors ? React.createElement(React.Fragment, undefined, React.createElement(MetafieldDrivenColorPicker$Showside.make, {
            product: product,
            inline: inline
          }), React.createElement(CustomerTheaterXyz$Showside.ColorPicker.make, {
            inline: inline,
            product: product
          })) : null, React.createElement(PDPForm$Showside.AllFields.make, tmp))), undefined, undefined, undefined, false, undefined);
        }
        if (param !== "cta") {
          if (param === "summary") {
            return make(pdpConfig.summarySections, product, selectedVariant, undefined);
          } else if (param === "quantity") {
            return Accordion$Showside.makeSection({
              TAG: /* Text */0,
              _0: "Quantity"
            }, "quantity", showQuantity ? Caml_option.some(renderQuantity(undefined)) : undefined, undefined, undefined, undefined, undefined, undefined);
          } else {
            return;
          }
        }
        var tmp$2;
        if (showFavoriteButton) {
          var tmp$3 = {
            product: product,
            at: inline ? /* PDPSticky */2 : /* PDP */1
          };
          if (tabIndex !== undefined) {
            tmp$3.tabIndex = Caml_option.valFromOption(tabIndex);
          }
          tmp$2 = Caml_option.some(React.createElement(Favorites$Showside.ToggleButton.make, tmp$3));
        } else {
          tmp$2 = undefined;
        }
        var tmp$4 = {
          product: product,
          variant: selectedVariant,
          isMobile: isMobile,
          size: inline ? /* Xl */3 : /* Lg */1,
          primary: showPrimaryCTA,
          secondary: !inline && showSecondaryCTA,
          tertiary: !inline && showTertiaryCTA
        };
        if (tmp$2 !== undefined) {
          tmp$4.extraButton = Caml_option.valFromOption(tmp$2);
        }
        if (tabIndex !== undefined) {
          tmp$4.tabIndex = Caml_option.valFromOption(tabIndex);
        }
        var partial_arg$1 = inline;
        return Accordion$Showside.makeSection(undefined, "cta buttons", Caml_option.some(React.createElement(CTABar$Showside.make, tmp$4)), function (param) {
          var inline = partial_arg$1 !== undefined ? partial_arg$1 : false;
          if (inline) {
            return param;
          }
          var match = settings.desktopPDPLayout;
          var tmp;
          switch (match) {
            case /* Old */0:
              tmp = /* Visible */3;
              break;
            case /* Horizontal */1:
              tmp = /* HiddenTop */0;
              break;
            case /* Vertical */2:
              tmp = /* HiddenBottom */1;
              break;
          }
          return React.createElement(PDPCTAWrapper$Showside.make, {
            style: {
              top: CSS$Showside.intToPx(productDetailsSize.height),
              zIndex: "1"
            },
            className: CSS$Showside.prefix(Cn.make([stickyCTA$1 ? "-mx-6 px-6" : "", stickyCTA$1 && isMobile ? "-mb-4" : "", stickyCTA$1 ? "sticky top-0 bg-main" : "relative", "mt-4 pb-4"])),
            initial: tmp,
            onChangeVisibility: onCTAButtonVisibilityChange,
            children: param
          });
        }, undefined, undefined, undefined, undefined);
      }), moreSections),
      onChangeFocus: function (id) {
        if (id === "description") {
          return Curry.app(trackEvent, ["product details:description", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
        }
      },
      titleStyle: largeTitleStyle,
      titleSize: titleSize,
      inline: inline
    });
  };
  var renderDetailedAccordions = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex-grow"]))
    }, React.createElement(PDPContentDetailsCard$DetailedAccordions, {
      variant: selectedVariant,
      product: product,
      detailedSections: pdpConfig.detailedSections
    }));
  };
  var tmp$1;
  switch (layout) {
    case /* SingleColumn */0:
      tmp$1 = {
        gridTemplateColumns: "minmax(0, 600px)"
      };
      break;
    case /* TwoColumns */1:
      tmp$1 = {
        gridTemplateColumns: "minmax(0, 591px) minmax(0, 591px)"
      };
      break;
    case /* Inline */2:
      tmp$1 = {
        gridTemplateColumns: "1fr"
      };
      break;
  }
  var tmp$2 = {
    className: CSS$Showside.prefix(Cn.make(["grid grid-rows-1 justify-center", layout !== 1 ? "" : "gap-x-6 gap-y-3 mb-8"]))
  };
  if (tmp$1 !== undefined) {
    tmp$2.style = Caml_option.valFromOption(tmp$1);
  }
  var match$4 = Belt_Array.some(sections, function (s) {
    return s === "promo";
  });
  var match$5 = Belt_Array.getBy(sections, function (section) {
    return section === "detailed";
  });
  var tmp$3;
  var exit = 0;
  switch (layout) {
    case /* SingleColumn */0:
      if (stickyCTA$1) {
        tmp$3 = renderAccordionContent(moreSections, undefined);
      } else {
        exit = 1;
      }
      break;
    case /* TwoColumns */1:
      tmp$3 = React.createElement("div", undefined, React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["flex-grow flex flex-col", layout !== 1 ? "" : "p-10 shadow-lg"]))
      }, showHeader ? headerContent$1 : null, renderAccordionContent(undefined, undefined)));
      break;
    case /* Inline */2:
      exit = 1;
      break;
  }
  if (exit === 1) {
    tmp$3 = React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex-grow flex flex-col", layout !== 1 ? "" : "p-10 shadow-lg"]))
    }, renderAccordionContent(undefined, undefined));
  }
  var match$6 = Belt_Array.getBy(sections, function (section) {
    return section === "detailed";
  });
  var tmp$4;
  var exit$1 = 0;
  if (layout !== 0 || !stickyCTA$1) {
    exit$1 = 1;
  } else {
    tmp$4 = null;
  }
  if (exit$1 === 1) {
    tmp$4 = React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex-grow"]))
    }, React.createElement(PDPContentDetailsCard$MoreSections, {
      product: product,
      moreSections: moreSections
    }));
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["flex-grow flex flex-col flex-shrink-0", layout !== 0 ? "" : singleColumnHorizontalPadding]))
  }, showHeader && layout !== 1 ? headerContent$1 : null, React.createElement("div", tmp$2, match$4 ? React.createElement(PDPContentDetailsCard$PromoSection, {
    data: pdpConfig.promoSection,
    product: product,
    variant: selectedVariant,
    layout: layout
  }) : null, layout !== 1 || match$5 === undefined ? null : React.createElement("div", undefined, renderDetailedAccordions(undefined)), tmp$3), React.createElement("div", undefined, layout !== 0 || match$6 === undefined ? null : React.createElement(React.Fragment, undefined, React.createElement("div", {
    className: CSS$Showside.prefix("border-t border-primary opacity-5 h-0 mt-4")
  }), renderDetailedAccordions(undefined), React.createElement("div", {
    className: CSS$Showside.prefix("border-t border-primary opacity-5 h-0")
  }))), tmp$4);
}
PDPContentDetailsCard.displayName = "PDPContentDetailsCard";
var make$1 = PDPContentDetailsCard;
export { DetailedAccordions, MoreSections, PromoSection, SummarySection, make$1 as make };
/* react Not a pure module */